import { render, staticRenderFns } from "./BodyAnatomyAdd.vue?vue&type=template&id=112649a8&scoped=true&"
import script from "./BodyAnatomyAdd.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112649a8",
  null
  
)

export default component.exports